import SaChannels from './SaChannels';

const SaChannelsConfig = {
	settings: {},
	routes: [
		{
			path: '/sa/channels',
			component: SaChannels
		}
	]
};

export default SaChannelsConfig;
